module.exports = __webpack_public_path__ + "static/media/Illustration-III.3e5721cf.svg";